import { Attr, Model } from "spraypaint";
import ApplicationRecord from "./ApplicationRecord";

@Model()
class ReassignOwnership extends ApplicationRecord {
  static jsonapiType = "users/reassign_ownership";

  @Attr() newOwnerId: number;
  @Attr() oldOwnerId: number;
}

export default ReassignOwnership;
